import React, { useState, lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermAndConditions } from "./pages/TermAndConditions";
import Layout from "./layouts/Layout";
import InvoiceNowV2 from "./pages/InvoiceNowV2";
import { WaitingNew } from "./pages/WaitingNew";
import UnlockBusinessEfficiency from "./pages/UnlockBusinessEfficiency";
import { Unauthorization } from "./pages/Unauthorization";
import { Pricing } from "./pages/Pricing";
import Contact from "./pages/Contact";
import { ContactUs } from "./pages/ContactUs";
import EInvoicing from "./pages/MyInvoicing";
import PressRelease from "./pages/PressRelease";

import { Freemium } from "./pages/FreemiumV2";
import VendorOnboarding from "./pages/VendorOnboarding";
import Faq from "./pages/Faq";
import VendorOnboardingSG from "./pages/VendorOnboardingSG";

// Logs the full URL on every in-app (client-side) navigation. Rendered inside
// <Router> so it has access to the router location.
function NavigationLogger() {
  const location = useLocation();
  useEffect(() => {
    console.log("[NAV] URL changed →", window.location.href, {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      key: location.key,
      state: location.state,
    });
  }, [location]);
  return null;
}

function MainRoute() {
  window.onpopstate = function () {
    console.log("[NAV] popstate fired @", window.location.href, "→ forcing window.history.go(-1)");
    window.history.go(-1);
  };

  // Logs whether the page was served fresh or restored from the back-forward
  // cache (bfcache). e.persisted === true means React state was frozen/restored,
  // so component code did NOT re-run.
  useEffect(() => {
    const onPageShow = (e: PageTransitionEvent) => {
      console.log("[NAV] pageshow @", window.location.href, "| persisted (bfcache):", e.persisted);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  const [baseName, setBaseName] = useState(process.env.REACT_APP_BASENAME ? process.env.REACT_APP_BASENAME : "");
  const mainPage = process.env.REACT_APP_MAIN_PAGE ? process.env.REACT_APP_MAIN_PAGE : "";
  async function getCountryCode() {
    try {
      const response = await fetch("https://api.country.is/");
      const data = await response.json();
      console.log(data.country.toLowerCase());
      return data.country_code.toLowerCase(); // Returns 'sg', 'my', etc.
    } catch (error) {
      return "sg"; // Returns 'sg', 'my', etc.
    }
  }

  function LocationBasedRedirect() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    var pathName = window.location.pathname;
    if (pathName == "/sg" || pathName == "/my" || pathName == "/" || pathName == undefined) pathName = "";
    useEffect(() => {
      const fetchCountryCode = async () => {
        try {
          var currentCountryCode = localStorage.getItem("country");
          if (!currentCountryCode || currentCountryCode == "" || currentCountryCode == "0") {
            const countryCode = await getCountryCode();
            localStorage.setItem("country", countryCode);
            currentCountryCode = countryCode;
          }
          console.log("currentCountryCode", currentCountryCode, pathName);
          console.log("[NAV] LocationBasedRedirect @", window.location.href, "→ navigate to:", `/${currentCountryCode}${pathName}`);
          navigate(`/${currentCountryCode}${pathName}`); // Redirect to /sg, /my, etc.
        } catch (error) {
          console.error("Failed to fetch country code", error);
          navigate("/"); // Default fallback to /us if unable to get country
        } finally {
          setLoading(false);
        }
      };

      fetchCountryCode();
    }, [navigate]);

    if (loading) {
      return <div>Loading...</div>; // Show loading while fetching location
    }

    return null; // Render nothing when redirecting
  }

  useEffect(() => {
    window.dataLayer?.push({ event: 'page_view', page_path: window.location.pathname + window.location.search });
  }, []);
  return (
    <Router basename={baseName}>
      <NavigationLogger />
      <Routes>
        {/* <Route element={<Layout />}> */}
        {/* {mainPage == "" && ( */}
        <Route
          path="/"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path="/:country/"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <UnlockBusinessEfficiency />
            </Suspense>
          }
        />
        {/* )} */}
        {/* {mainPage == "tnc" && ( */}
        <Route
          path="/:country/terms-conditions"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <TermAndConditions />
            </Suspense>
          }
        />
        <Route
          path="/terms-conditions"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <TermAndConditions />
            </Suspense>
          }
        />
        {/* )} */}
        {/* {mainPage == "pp" && ( */}
        <Route
          path="/:country/privacy-policy"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <PrivacyPolicy />
            </Suspense>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <PrivacyPolicy />
            </Suspense>
          }
        />
        <Route
          path="/:country/contact"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ContactUs />
            </Suspense>
          }
        />
        <Route
          path="/contact"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ContactUs />
            </Suspense>
          }
        />
        <Route
          path="/vendor-onboarding"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <VendorOnboarding />
            </Suspense>
          }
        />
        <Route
          path="/:country/vendor-onboarding"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <VendorOnboarding />
            </Suspense>
          }
        />
        <Route
          path="/vendor-onboarding-sg"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <VendorOnboardingSG />
            </Suspense>
          }
        />
        <Route
          path="/:country/vendor-onboarding-sg"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <VendorOnboardingSG />
            </Suspense>
          }
        />
        {/* )} */}
        {/* </Route> */}
        <Route
          path="/news"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path="/news/:url"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path="/:country/news/:url"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <PressRelease />
            </Suspense>
          }
        />
        <Route
          path="/:country/news"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <PressRelease />
            </Suspense>
          }
        />
        <Route
          path="/invoicenow"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path="/:country/invoicenow"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <InvoiceNowV2 />
            </Suspense>
          }
        />
        <Route
          path="/e-invoicing"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path="/:country/e-invoicing"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <EInvoicing />
            </Suspense>
          }
        />
        <Route
          path={"/timing"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <WaitingNew />
            </Suspense>
          }
        />
        <Route
          path={"/404"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Unauthorization />
            </Suspense>
          }
        />
        <Route
          path={"/:country/pricing/:mode"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Pricing />
            </Suspense>
          }
        />
        <Route
          path={"/:country/pricing/"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Pricing />
            </Suspense>
          }
        />
        <Route
          path={"/pricing/:mode"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path={"/pricing"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path={"/:country/contact/:site/:subUrl"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Contact />
            </Suspense>
          }
        />
        <Route
          path={"/:country/contact/:subUrl"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Contact />
            </Suspense>
          }
        />
        <Route
          path={"/contact/:site/:subUrl"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Contact />
            </Suspense>
          }
        />
        <Route
          path={"/contact/:subUrl"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Contact />
            </Suspense>
          }
        />
        <Route
          path={"/:country/freemium/"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Freemium />
            </Suspense>
          }
        />
        <Route
          path={"/freemium"}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path="/faq"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LocationBasedRedirect />
            </Suspense>
          }
        />
        <Route
          path="/:country/faq"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Faq />
            </Suspense>
          }
        />
        <Route
          path="/:country/faq/:queryParam"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Faq />
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

export default MainRoute;
